export default __webpack_public_path__ + "static/Rare_Flower-6c767b89b4d261f55fe05fb3fd80a1e2.png";